export const COLOR = {
  red: '#ff0000',
  green: '#00ff00',
  yellow: '#ffff00',
  orange: '#ffa500',
  white: '#fff',
};
